module.exports = __webpack_public_path__ + "components/outside-promo-page/static/companies-6dcb24512a90a3a45cdffbcb9e3c3ad3.svg";